import type { DashboardWidgetConfiguration } from './widget-definition';
import { period } from './query-period';

export const locationValueTrendWidget: DashboardWidgetConfiguration = {
  widgetId: "location.value-trend",
  name: "Inventory cost over time",
  description: "Daily closing inventory value at cost for this site, including days without movements. The headline is current inventory value.",
  apps: [
    "configuration",
  ],
  template: "graph",
  query: {
    kind: "graph",
    valueQuery: {
      version: 1,
      source: "inventory.stock",
      ...period(30),
      select: [
        {
          type: "aggregate",
          function: "sum",
          field: "inventory_value",
          as: "value",
        },
      ],
    },
    graphQueries: [
      {
        name: "Inventory value at cost",
        query: {
          version: 1,
          source: "inventory.location-value-daily",
          ...period(30),
          select: [
            {
              type: "field",
              field: "as_of_date",
              bucket: "day",
              as: "day",
            },
            {
              type: "aggregate",
              function: "sum",
              field: "stock_value",
              as: "value",
            },
          ],
          group_by: [
            {
              field: "as_of_date",
              bucket: "day",
            },
          ],
          order_by: [
            {
              ref: "day",
              direction: "asc",
            },
          ],
        },
        type: "area",
        color: "#2fb344",
        lineWidth: 2,
        fillOpacity: 0.16,
        valueMultiplier: 1,
      },
    ],
  },
  inputs: {
    title: "Inventory cost over time",
    valueFormat: "currency",
    valueMultiplier: 1,
    graphPadding: true,
    chartHeight: 112,
    curve: "smooth",
  },
  dummyData: {
    value: "0",
    series: [
      18,
      24,
      20,
      32,
      29,
      41,
      48,
    ],
  },
  limits: {
    minWidth: 3,
    maxWidth: 12,
    minHeight: 2,
    maxHeight: 6,
    defaultWidth: 6,
    defaultHeight: 3,
  },
};
